import { StringKit } from '@team/string';

export function stringOrFallback<T extends string, U>(
  value: T,
  fallback: U
): T | U {
  if (StringKit.isEmpty(value)) {
    return fallback;
  }

  return value;
}
